module.exports = __webpack_public_path__ + "img/4F4742_B7B1AA_847E79_969294-256px.cc8e5f48.png";